module.exports = __webpack_public_path__ + "img/pt.62f94dab.png";